export function compressImage(file, maxSizeKB = 250, quality = 0.8) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = (event) => {
        const img = new Image();
        img.src = event.target.result;
        img.onload = () => {
          const canvas = document.createElement('canvas');
          const ctx = canvas.getContext('2d');
  
          // Maintain aspect ratio
          const MAX_WIDTH = 800;
          const scaleSize = MAX_WIDTH / img.width;
          canvas.width = MAX_WIDTH;
          canvas.height = img.height * scaleSize;
  
          ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
  
          // Recursive function to adjust quality
          function adjustQuality(q) {
            canvas.toBlob(
              (blob) => {
                if (blob.size / 1024 > maxSizeKB && q > 0.1) {
                  adjustQuality(q - 0.1); // Reduce quality
                } else {
                  resolve(blob);
                }
              },
              'image/jpeg',
              q
            );
          }
          adjustQuality(quality);
        };
        img.onerror = (err) => reject(err);
      };
      reader.onerror = (err) => reject(err);
    });
  }
  
  